import StatCard from '../components/shared/StatCard';
import CTABanner from '../components/dashboard/CTABanner';
import InvitationBanner from '../components/dashboard/InvitationBanner';
import RecentGames from '../components/dashboard/RecentGames';
import DayStreakCard from '../components/dashboard/DayStreakCard';
import QuickActionItem from '../components/dashboard/QuickActionItem';
import LeaderboardWidget from '../components/dashboard/LeaderboardWidget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchMyGames } from '../apiservices/axiosservice/subscriberservice';
import {
  faStar,
  faBullseye,
  faPen,
  faPuzzlePiece,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import { useEffect, useState } from 'react';
import { getSubscriber } from '../apiservices/LocalStorageService';

const leaderboardEntries = [];

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [games, setGames] = useState<GamesPaginated>();

  useEffect(() => {
    const user = getSubscriber();
    if (!user?.userId) return;
    fetchMyGames({
      gameOwnerId: user.userId,
      page: 1,
      limit: 4,
    })
      .then((res) => {
        setGames(res.data);
      })
      .catch((err) => {});
  }, []);

  const activeGame = games?.games?.find(
    (g) => g.gameStatus !== 'FINISHED' && g.gameStatus !== 'ENDED'
  );

  return (
    <div className="home-page">
      <div className="home-page__banners">
        <CTABanner />
        {activeGame && (
          <InvitationBanner
            gameName={activeGame.gameTitle}
            host="You"
            playerCount={activeGame.maxSession || 0}
            onJoin={() =>
              navigate(`/dashboard/games/game/${activeGame.gameId}/lobby`, {
                state: {
                  gameType: activeGame.gameType,
                  gameStatus: activeGame.gameStatus,
                  gameTitle: activeGame.gameTitle,
                },
              })
            }
          />
        )}
      </div>

      <div className="home-page__stats">
        <StatCard
          icon="🎮"
          value={games?.totalGames ?? 0}
          label="Games Created"
        />
        <StatCard icon="🏆" value="0" label="Best Score" />
        <StatCard icon="🔥" value={0} label="Day Streak" />
      </div>

      <RecentGames />

      {/* Mobile-only: right panel content inlined */}
      <div className="home-page__mobile-extras">
        <button
          className="home-page__mobile-create"
          onClick={() => navigate('/dashboard/games')}
        >
          + Create Game
        </button>
        <DayStreakCard streak={0} />
        <h4 className="home-page__mobile-section-title">Quick Actions</h4>
        <QuickActionItem
          icon={<FontAwesomeIcon icon={faStar} />}
          label="Smart Quiz"
          onClick={() => navigate('/dashboard/games/smart')}
        />
        <QuickActionItem
          icon={<FontAwesomeIcon icon={faBullseye} />}
          label="Geo Guess"
          onClick={() => navigate('/dashboard/games/geo')}
        />
        <QuickActionItem
          icon={<FontAwesomeIcon icon={faPuzzlePiece} />}
          label="Sketcher"
          onClick={() => navigate('/dashboard/games/sketcher')}
        />

        <LeaderboardWidget title="" entries={leaderboardEntries} />
      </div>
    </div>
  );
};

export default HomePage;
